import React from 'react'
import fries from 'assets/img/fries.jpg'
import ImageSection from '../ImageSection'

export default function SaveTime({ className, ...props }) {
  return (
    <ImageSection
      imageUrl={fries}
      className={['md:text-black', className]}
      heading="Save Time"
      description={`
        Compare hundreds of food trucks in one place. We negotiate the best rate,
        coordinate logistics, and make sure the food truck shows up with
        everything you need. That gives you more time to salivate over the menu.
      `}
      {...props}
    />
  )
}
